// extracted by mini-css-extract-plugin
export default {"heading":"heading--mp-OUPfb","dot":"dot--mp-SNtgr","links":"links--mp-N7RbY","link":"link--mp-Pbu89"};